export type ProfileSocialProvider =
  | 'facebook'
  | 'instagram'
  | 'twitter'
  | 'linkedin'
  | 'youtube'
  | 'tiktok'
  | 'website';

export type ProfileSocialConnectionStatus =
  | 'connected'
  | 'disconnected'
  | 'needs_public_url'
  | 'failed';

export type ProfileSocialConnectionRedirectResult =
  | 'connected'
  | 'disconnected'
  | 'needs_public_url'
  | 'failed'
  | 'needs_page_selection'
  | 'needs_page_creation';

export type ProfileTab = 'athletic' | 'artistic' | 'services' | 'college';

export interface ProfileStat {
  label: string;
  value: number;
}

export interface ProfileSocialLink {
  provider: ProfileSocialProvider;
  label: string;
  icon: string;
  variant: ProfileSocialProvider;
  href?: string;
  status: ProfileSocialConnectionStatus;
  statusLabel: string;
  primaryActionLabel: string;
  helperText?: string;
  canDisconnect: boolean;
}

export interface ProfileExperienceCardRow {
  label: string;
  value: string;
  accent?: boolean;
}

export interface ProfileExperienceCard {
  id: string;
  title: string;
  rows: ProfileExperienceCardRow[];
}

export interface ProfileFeatureCard {
  id: string;
  title: string;
  description: string;
  icon?: string;
}

export interface ProfileTabOption {
  id: ProfileTab;
  label: string;
}

export const PROFILE_TAB_OPTIONS: ProfileTabOption[] = [
  {id: 'athletic', label: 'Athletic'},
  {id: 'artistic', label: 'Artistic'},
  {id: 'services', label: 'Services'},
  {id: 'college', label: 'College/University'},
];

export const PROFILE_FEATURE_CARDS: ProfileFeatureCard[] = [
  {
    id: 'direct-messaging',
    title: 'Direct Messaging',
    description: 'Send messages to other users',
    icon: 'message-fill.svg',
  },
  {
    id: 'post-comments',
    title: 'Post Comments',
    description: 'Comment on user posts',
    icon: 'comment-outline.svg',
  },
  {
    id: 'follow-system',
    title: 'Follow System',
    description: 'Follow and be followed',
    icon: 'user-group.svg',
  },
  {
    id: 'media-uploads',
    title: 'Media Uploads',
    description: 'Share photos and videos',
    icon: 'media-outline.svg',
  },
  {
    id: 'talent-search',
    title: 'Talent Search',
    description: 'Discover talented users',
    icon: 'search-line.svg',
  },
  {
    id: 'safety-features',
    title: 'Safety Features',
    description: 'Guardrails, reports, and location controls',
    icon: 'safety-outline.svg',
  },
];
